import React, { Component } from 'react';
import * as encryptUtils from './encryptDecryptUtils';
import * as loggingUtils from "./utils/loggingUtils";
import './NFTEditionsLivestream.css';

class NFTEditionsLivestream extends Component {
  constructor(props) {
    super(props);
    this.purchaseItem = this.purchaseItem.bind(this);

    this.state = {
    }
  }

  async purchaseItem() {
    if(this.props.address == null) {
      return;
    }
    loggingUtils.logEvent(
      this.props.address != null
        ? this.props.address
        : encryptUtils.getWalletUnconnectedUserId(),
      "livestream_page",
      "livestream_page_purchase_item",
      "info",
      "https://the402.xyz",
      {}
    );
    this.props.setTransactionStatus("Pending");
    if(this.props.nftSalesLivestream.type === "manifold721") {
      let didApprove = await encryptUtils.buyManifold721Emote(
        this.props.address,
        this.props.nftSalesLivestream.contractAddress,
        this.props.nftSalesLivestream.claimIndex,
        this.props.nftSalesLivestream.price
      );
      if(didApprove) {
        loggingUtils.logEvent(
          this.props.address != null
            ? this.props.address
            : encryptUtils.getWalletUnconnectedUserId(),
          "external_purchases",
          "external_purchase",
          "info",
          "https://the402.xyz",
          {
            "type": this.props.nftSalesLivestream.type,
            "price": this.props.nftSalesLivestream.price,
            "contractAddress": this.props.nftSalesLivestream.contractAddress
          }
        );
        this.props.setTransactionStatus("Purchase Complete");
      } else {
        this.props.setTransactionStatus("None");
      }
    } else if(this.props.nftSalesLivestream.type === "manifold1155") {
      let didApprove = await encryptUtils.buyManifold1155Emote(
        this.props.address,
        this.props.nftSalesLivestream.contractAddress,
        this.props.nftSalesLivestream.price,
        this.props.nftSalesLivestream.tokenId
      );
      if(didApprove) {
        loggingUtils.logEvent(
          this.props.address != null
            ? this.props.address
            : encryptUtils.getWalletUnconnectedUserId(),
          "external_purchases",
          "external_purchase",
          "info",
          "https://the402.xyz",
          {
            "type": this.props.nftSalesLivestream.type,
            "price": this.props.nftSalesLivestream.price,
            "contractAddress": this.props.nftSalesLivestream.contractAddress
          }
        );
        this.props.setTransactionStatus("Purchase Complete");
      } else {
        this.props.setTransactionStatus("None");
      }
    } else if(this.props.nftSalesLivestream.type === "zora721") {
      let didApprove = await encryptUtils.buyZora721Emote(
        this.props.address,
        this.props.nftSalesLivestream.contractAddress,
        this.props.nftSalesLivestream.price
      );
      if(didApprove) {
        loggingUtils.logEvent(
          this.props.address != null
            ? this.props.address
            : encryptUtils.getWalletUnconnectedUserId(),
          "external_purchases",
          "external_purchase",
          "info",
          "https://the402.xyz",
          {
            "type": this.props.nftSalesLivestream.type,
            "price": this.props.nftSalesLivestream.price,
            "contractAddress": this.props.nftSalesLivestream.contractAddress
          }
        );
        this.props.setTransactionStatus("Purchase Complete");
      } else {
        this.props.setTransactionStatus("None");
      }
    } else if(this.props.nftSalesLivestream.type === "poap") {
      let didApprove = await encryptUtils.claimPOAP(this.props.address);
      if(didApprove) {
        loggingUtils.logEvent(
          this.props.address,
          "poap",
          "poap_claim",
          "info",
          "https://the402.xyz",
          {
            "type": this.props.nftSalesLivestream.type
          }
        );
        this.props.setTransactionStatus("Claim Complete");
      } else {
        this.props.setTransactionStatus("None");
      }
    }
  }

  render() {
    if(this.props.nftSalesLivestream == null || Object.keys(this.props.nftSalesLivestream).length === 0) {
      return null;
    }
    // TODO reinstate audio tag here
    return (
      <div>
        <div className="mt-8 border-2 border-gray-200 rounded-t-none cursor-pointer dark:border-zinc-800 w-screen sm:w-60 mx-auto mb-8 dark:bg-custom-gray bg-gray-100 rounded-none sm:rounded-xl">
          <div className="h-64">
            <img className="sm:hover:-translate-y-0 sm:hover:scale-105 duration-500 object-cover bg-black h-60 w-full sm:h-60 sm:w-60 rounded-none sm:rounded-xl shadow-[0_4px_20px_rgba(0,0,0,0.4)]" src={this.props.nftSalesLivestream.image} />
            {
              this.props.nftSalesLivestream.animation_url !== ""
                ?
              <audio
                src={this.props.nftSalesLivestream.animation_url}
                className="w-full h-8 my-2"
                autoPlay={false}
                controls
              >
              </audio>
                :
              <div className="w-full h-8 my-2"> </div>
            }
            <div className="mt-28 rounded-t-xl rounded-b-md relative bg-black bg-opacity-30 bottom-[392px] py-2 z-0">
              <div className="flex mr-8 justify-between relative text-white font-medium left-4 z-10">
                {this.props.nftSalesLivestream.artist}
              </div>
              <div className="relative text-xl text-white font-bold left-4 z-10">
                {this.props.nftSalesLivestream.collection}
              </div>
            </div>
          </div>
          <div className="flex flex-col cursor-pointer">
            <div className="p-4 flex bg-gray-100 dark:bg-custom-gray">
              <div className="flex flex-col">
                <div className="mt-6 w-9/12 h-10 flex items-center overflow-hidden text-ellipsis text-sm font-medium text-black dark:text-white">
                  {this.props.nftSalesLivestream.item}
                </div>
              </div>
              <div className="flex inline-flex w-14 ml-1">
              </div>
            </div>
            <div className="h-28 bg-gray-100 dark:bg-custom-gray dark:border-t-1 dark:border-zinc-800 border-t-2 flex flex-col justify-center">
              <div className="flex justify-around">
                <div>
                  <button
                    className="hover:-translate-y-0 hover:scale-105 duration-500 mx-auto bg-custom-black dark:bg-gray-200 h-12 w-52 font-semibold justify-center items-center rounded-lg flex font-medium text-white dark:text-black cursor-pointer"
                    onClick={async () => await this.purchaseItem()}
                  >
                    {this.props.nftSalesLivestream.price > 0 ? "Buy": "Claim"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default NFTEditionsLivestream;
